import { getDocsLink } from '@cast/utils';

import { ExternalLink, Typography, Stack } from '@cast/design-system';

type DialogDescriptionProps = {
  hasSchedulesAssigned: boolean;
  assignedScheduleName: string;
};

export const DialogDescription = ({
  hasSchedulesAssigned,
  assignedScheduleName,
}: DialogDescriptionProps) => {
  return (
    <Stack gap={16}>
      <Typography variant="h5" data-testid="resume-cluster-dialog-title">
        {hasSchedulesAssigned
          ? 'Review node configuration for resumption'
          : 'Specify node configuration for resumption'}
      </Typography>
      <Typography variant="P12R" color="textSecondary">
        {hasSchedulesAssigned
          ? `This cluster was hibernated according to the schedule "${assignedScheduleName}".
                    The node configuration used for hibernation is displayed below.
                    You can review and modify it if needed before resuming the cluster.`
          : `To resume this cluster, you need to provide the node configuration
                    that will be used. You can either import a configuration from an
                    existing schedule or enter it manually. See the API documentation
                    for supported parameters.`}{' '}
        <ExternalLink
          link={getDocsLink('docs_resume_cluster_node_config')}
          sx={{ typography: 'P12M' }}
        >
          Documentation
        </ExternalLink>
      </Typography>
    </Stack>
  );
};
